import { Table } from '@tanstack/react-table';
import { useMemo } from 'react';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import {
  MaskTemplateEntity,
  OnOpenMask,
} from '../../containers/mask-overlays/mask-overlay/types';

import { useEntityHandlers } from './use-entity-handlers';

export function useTableHandlersV8(
  table: Table<unknown>,
  entity: Entities,
  onOpenMask: OnOpenMask,
  template: MaskTemplateEntity | null = null
) {
  const rows = table.getSelectedRowModel().flatRows;

  const entries = useMemo(() => {
    return rows.filter((row) => !row.getIsGrouped()).map((row) => row.original);
  }, [rows]);

  return useEntityHandlers({
    entity,
    onOpenMask,
    template,
    entries,
  });
}
